import React, { Component, Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardTitle, Form, Label, Input, Button, timeoutsShape } from "reactstrap";
import { NavLink } from "react-router-dom";

import { Colxx } from "Components/CustomBootstrap";

import { connect } from "react-redux";
import { loginUser } from "Redux/actions";

class LoginLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      email: "",
      password: ""
    };
  }
  onUserLogin() {

    if (this.state.email !== "" && this.state.password !== "") {
      this.setState({ isLoading: true });
      this.props.loginUser(this.state, this.props.history, this);

    }
  }

  componentDidMount() {
    document.body.classList.add("background");
  }
  componentWillUnmount() {
    document.body.classList.remove("background");
  }
  render() {
    return (
      <Fragment>
        <div className="fixed-background" />
        <main>
          <div className="container">
            <Row className="h-100">

              <Colxx xxs="12" md="10" className="mx-auto my-auto">

                <Card className="auth-card">
                  <div className="position-relative image-side ">
                    <p className="text-white h2">پلتفرم مدیریت فروش عکسچاپ</p>
                    <p className="white mb-0">
                      لطفا وارد پنل خود شوید.
                      <br />
                      اگر در ورود به سیستم مشکلی دارید لطفا به مدیر سیستم اطلاع دهید.

                    </p>
                  </div>
                  <div className="form-side">
                    <NavLink to={`/`} className="white">
                      <span className="logo-single" style={{ width: "247px", height: "107px" }} />
                    </NavLink>
                    <br />
                    <CardTitle className="mb-4">
                      <IntlMessages id="user.login-title" />
                    </CardTitle>

                    <Form>
                      <Label className="form-group has-float-label mb-4">
                        <Input type="email" defaultValue={this.state.email} disabled={this.state.isLoading} onChange={(e) => { this.setState({ email: e.target.value }); }} />
                        <IntlMessages id="user.username" />
                      </Label>
                      <Label className="form-group has-float-label mb-4">
                        <Input type="password"
                          disabled={this.state.isLoading}
                          onChange={(e) => { this.setState({ password: e.target.value }); }}
                        />
                        <IntlMessages
                          id="user.password"
                          defaultValue={this.state.password}
                        />
                      </Label>

                      <div className="">
                        {/* <NavLink to={`/forgot-password`}> */}
                        {/* <IntlMessages id="user.forgot-password-question" /> */}
                        {/* </NavLink> */}
                        
                          <Button
                            color="primary"
                            className="default mb-2 btn-shadow"
                            size="lg"
                            disabled={this.state.isLoading}
                            style={{ float: "left" }}
                            onClick={() => this.onUserLogin()}
                          >
                            <IntlMessages id="user.login-button" />
                          </Button>
                      </div>
                    </Form>

                  </div>
                </Card>
              </Colxx>

            </Row>
          </div>
        </main>
      </Fragment>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading } = authUser;
  return { user, loading };
};

export default connect(
  mapStateToProps,
  {
    loginUser
  }
)(LoginLayout);
